import React, { memo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button, Col, Row } from 'redpoints-front-components/index';
import { withContext } from 'redpoints-front-common/components';
import { redirect } from 'redpoints-front-common/helpers';

import {
  testPurchaseClearFilters,
  testPurchaseFetchLinkInfo,
} from '../../../actions/testPurchaseActions';
import { getTestPurchaseFiltersSelected } from '../../../reducers/tasks/testPurchase';
import { ROUTES } from '../../../config/constants';
import { translate } from '../../../helpers/languageHelper';
import { getContextDataFromFilterBy } from './testPurchaseFiltersHelpers';

const TestPurchaseFiltersActions = ({
  context,
  filtersSelected: { allDomainIds, domainId, domainPlatformId, filterBy },
  hasFiltersApplied,
  testPurchaseClearFilters,
  testPurchaseFetchLinkInfo,
}) => {
  const { customerId, contractId } = getContextDataFromFilterBy(
    filterBy,
    context
  );

  const handleApply = () => {
    testPurchaseFetchLinkInfo({
      allDomainIds,
      contractId,
      customerId,
    });

    redirect({
      queryParams: {
        domainId,
        domainPlatformId,
        filterBy,
      },
      urlRoute: ROUTES.TEST_PURCHASE,
    });
  };

  const handleClear = () => {
    testPurchaseClearFilters();

    redirect({
      urlRoute: ROUTES.TEST_PURCHASE,
    });
  };

  const isApplyDisabled = hasFiltersApplied;
  const isClearDisabled = !domainId.length && !domainPlatformId.length;

  return (
    <Row gutter={16}>
      <Col flex="auto">
        <Button
          type="primary"
          size="fit"
          disabled={isApplyDisabled}
          onClick={handleApply}
          aria-label="button-apply"
        >
          {translate('tasks.testPurchase.filter.apply')}
        </Button>
      </Col>
      <Col flex="none">
        <Button
          type="secondary"
          disabled={isClearDisabled}
          onClick={handleClear}
          size="fit"
          aria-label="button-clear"
        >
          {translate('tasks.testPurchase.filter.clear')}
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = state => ({
  filtersSelected: getTestPurchaseFiltersSelected(state),
});

export default compose(
  withContext,
  connect(mapStateToProps, {
    testPurchaseClearFilters,
    testPurchaseFetchLinkInfo,
  }),
  memo
)(TestPurchaseFiltersActions);
